// Ticket #257: wording for the background ACC asset run, shared by the CSV
// import modal and the Packages page.

// Why a run stopped early (accPackageAssetWorker stoppedReason). Packages it did
// not reach stay pending on the server.
export const ACC_STOP_MESSAGES = {
  auth_expired:
    'The Autodesk connection has expired. Reconnect ACC, then use "Create pending ACC assets" on the Packages page.',
  acc_forbidden:
    "Your Autodesk account does not have access to this project's ACC assets. The remaining packages are still pending.",
  acc_unavailable:
    'ACC was unavailable. The remaining packages are still pending; retry from the Packages page.',
  env_guard:
    'Outbound ACC writes are turned off in this environment. The packages are pending.',
  project_sync_off:
    'ACC asset sync is off for this project. The packages are pending.',
  project_not_linked:
    'This project is not linked to ACC. The packages are pending.',
  inbound_sync_running:
    'An ACC sync was running for too long. The packages are pending; retry when it finishes.',
  project_setup_incomplete:
    "This project's ACC status set is missing. Turn ACC asset sync off and on again.",
  acc_unexpected_response:
    'ACC returned an unexpected response. The packages are pending; contact an administrator.',
  save_failed:
    'ACC assets were created but could not be saved. The packages are pending; retrying links the existing assets instead of creating new ones.',
  crashed:
    'ACC asset creation stopped unexpectedly. The packages are pending; retry from the Packages page.',
};

// Ticket #268: a package deleted in development/staging keeps its ACC asset,
// because outbound ACC writes are blocked there (accOutboundGuard).
export const ACC_ENV_GUARD_DELETE_NOTE =
  'Its ACC asset was not archived because ACC writes are turned off in this environment (development/staging).';

// Server errors are prefixed with the service name; it adds nothing here.
export const stripAccPrefix = (message) =>
  String(message || '').replace(/^Autodesk Construction Cloud:\s*/, '');

/** Readable reason a finished run stopped early, or null if it did not. */
export const accStopMessage = (progress) =>
  progress?.stoppedReason
    ? ACC_STOP_MESSAGES[progress.stoppedReason] ||
      stripAccPrefix(progress.lastError) ||
      'ACC asset creation stopped early. The remaining packages are pending.'
    : null;
